import React, {ReactNode} from 'react';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import {BreadcrumbModel} from '../../api/types.ts';

interface PageHeaderProps {
    title: ReactNode;
    // Says what the page is for, or who can see it.
    description?: ReactNode;
    // Secondary first, primary last.
    actions?: ReactNode;
    tabs?: ReactNode;
    filters?: ReactNode;
    // "8 whiteboard projects"
    resultCount?: ReactNode;
    // Only shown two or more levels deep: the parents, without the page itself.
    breadcrumb?: BreadcrumbModel[];
    className?: string;
}

/*
 * The top of every page, laid out the same way: title and description on
 * the left, actions on the right, then tabs, then one filter bar with the
 * result count under it. Top-level pages have no breadcrumb.
 */
const PageHeader: React.FC<PageHeaderProps> = ({
    title,
    description,
    actions,
    tabs,
    filters,
    resultCount,
    breadcrumb,
    className
}) => (
    <header className={classNames('mx-page-header', className)}>
        {breadcrumb && breadcrumb.length >= 1 && (
            <nav aria-label="Breadcrumb" className="mx-breadcrumb">
                <ol>
                    {breadcrumb.map(crumb => (
                        <li key={crumb.href}>
                            <Link to={crumb.href}>{crumb.title}</Link>
                        </li>
                    ))}
                </ol>
            </nav>
        )}
        <div className="mx-page-header-row">
            <div className="mx-page-header-text">
                <h1 className="mx-page-title">{title}</h1>
                {description && (
                    <p className="mx-page-description">{description}</p>
                )}
            </div>
            {actions && <div className="mx-page-actions">{actions}</div>}
        </div>
        {tabs && <div className="mx-page-tabs">{tabs}</div>}
        {filters && <div className="mx-page-filters">{filters}</div>}
        {resultCount && <div className="mx-page-count">{resultCount}</div>}
    </header>
);

export default PageHeader;
